import getT from "../getT";

export default function ({bands, parts}) {
    const total_counts = parts?.reduce((acc, item) => Number(item?.count) + Number(acc), 0);
    return `
    <table>
      <caption>${getT("Детали")}:   </caption>
        <thead>
    <tr>
      <th rowspan="2">#</th>
      <th rowspan="1" colspan="2">${getT("Пильный размер")}</th>
      <th rowspan="1" colspan="2">${getT("Размер с кромкой")}</th>
      <th  rowspan="2">${getT("Кол-во")}</th>
      <th  rowspan="2">${getT("Верх")}</th>
      <th  rowspan="2">${getT("Низ")}</th>
      <th  rowspan="2">${getT("Лево")}</th>
      <th  rowspan="2">${getT("Право")}</th>
      <th  rowspan="2">${getT("Текстура")}</th>
      <th  rowspan="2">${getT("Тип кромкования")}</th>
      <th  rowspan="2">${getT("Описание")}</th>
    </tr>
    <tr>
    <th>${getT("Длина")}</th>
    <th>${getT("Ширина")}</th>
    <th>${getT("Длина")}</th>
    <th>${getT("Ширина")}</th>
</tr>
  </thead>
        <tbody>
  ${parts?.map((part, index) => {
        let find_band = (band_id) => (item) => Number(item?.id) === Number(band_id);
        let band_t = bands?.findIndex(find_band(part.edge.t?.db_id)) >= 0 ? bands?.findIndex(find_band(part.edge.t?.db_id)) + 1 : '';
        let band_b = bands?.findIndex(find_band(part.edge.b?.db_id)) >= 0 ? bands?.findIndex(find_band(part.edge.b?.db_id)) + 1 : '';
        let band_l = bands?.findIndex(find_band(part.edge.l?.db_id)) >= 0 ? bands?.findIndex(find_band(part.edge.l?.db_id)) + 1 : '';
        let band_r = bands?.findIndex(find_band(part.edge.r?.db_id)) >= 0 ? bands?.findIndex(find_band(part.edge.r?.db_id)) + 1 : '';
        let display_total = (parts?.length - 1) === index
        return `
            <tr>
                <td>${part.id}</td>
                <td>${part?.x}</td>
                <td>${part?.y}</td>
                 <td>${part?.x1}</td>
                <td>${part?.y1}</td>
                <td>${part?.count}</td>
                <td>${band_t}</td>
                <td>${band_b}</td>
                <td>${band_l}</td>
                <td>${band_r}</td>
                <td>${!!Number(part?.texture) ? '+' : ''}</td>
                <td>${part?.edge_type_part}</td>
                <td>${part?.info_user}</td>
            </tr>
            ${part?.goods_service_added_firm?.length &&

        `
        <tr><th colspan="13">
 ${getT("Доп. услуги к детали")}
</th></tr>
       ${part?.goods_service_added_firm?.map(item => {
            return `
        <tr>
        <td colspan="1">${part?.id}</td>
        <td colspan="2" style="text-align: left">${item?.name} [${item.id}]</td>
        <td colspan="3"> ${getT("Кол-во детали")}: ${item?.value_detail}</td>
        <td colspan="3"> ${getT("Кол-во")}: ${item?.count}</td>
        <td colspan="2">${getT('Стоимость')}:${item?.price} ${item.currency_name}</td>
        <td colspan="2">${getT('Сумма')}:${Number(item?.price * item.count).toFixed(2)} ${item.currency_name}</td>
        </tr>
        `
        })?.join('')}`

        }
        `
    })?.join('')}
  <tr>
    <th colspan="4" class="b-left-hide b-bottom-hide"></th>
    <th colspan="1">${getT("Всего")}</th>
    <th colspan="1"> ${total_counts}</th>
    <th colspan="7"  class="b-right-hide b-bottom-hide"></th>
</tr>
     </table>
    `
}
